import type { AnnotationStudioLocalizedText } from "@carbon6/c6-frontend-design/annotation";
import type { GpuCapacitySnapshot } from "./gpuCapacityController";

// Annotation 상류(프레임 디코드·SAM)는 GPU holder pod 위에서 실행된다. training-infra 의 sam-preview
// Service 는 holder pod 라벨로 엔드포인트를 모은다. 그래서 Running holder 가 0 이면 그 서비스는
// 비어 있고, 캡처·Tracking 은 누른 뒤에 실패한다. 이 게이트가 여유 GPU(free_gpus)가 아니라 holder
// 점유를 보는 이유다. 여유가 있어도 holder 가 아직 시작되지 않은 구간(분당 하나씩 램프업)에는
// 똑같이 실패한다.
//
// 첫 로드 전(null)에는 막지 않는다. 값을 모를 때 막으면, 위젯이 늦게 로드된 사람이 이유 없이
// 막힌다. 직전 조회가 실패한 스냅샷(stale)도 마지막 값으로 판정한다. 15초 폴링이므로 대개 맞다.
// 틀려도 결과는 게이트가 없을 때처럼 누른 뒤 실패하는 것뿐이다.
export function annotationUpstreamBlocked(snapshot: GpuCapacitySnapshot): boolean {
  return snapshot.data !== null && snapshot.data.holder_running_gpus === 0;
}

// 차단 사유 한 문장이다. 탭 클릭 모달·스튜디오 잠금·상류 503 번역이 같은 문장을 쓰도록 여기서 소유한다.
// c6 스튜디오의 `AnnotationOperationAvailability.localizedReason` 형태이므로 그대로 전달한다.
export const gpuUnavailableForAnnotationReason: AnnotationStudioLocalizedText = {
  ko: "지금은 GPU 가 없어 Annotation을 할 수 없습니다. 실행 중인 Training·Evaluation이 끝나 GPU 가 비면 자동으로 다시 열립니다.",
  en: "Annotation is unavailable right now because no GPU is free. It reopens automatically once running training or evaluation releases a GPU.",
};
